const faqs = [
  {
    q: '吃瓜爆料是什么平台？',
    a: '吃瓜爆料是国内领先的娱乐热点与爆料聚合平台，汇集全网最新吃瓜爆料黑料、吃瓜爆料视频、吃瓜爆料每日大赛等精彩内容。我们致力于为吃瓜群众提供真实、及时、全面的每日热点爆料吃瓜资讯。',
  },
  {
    q: '吃瓜爆料的内容来源可靠吗？',
    a: '平台内容主要来自用户投稿、公开信息整理以及合作媒体供稿。我们会对每一条爆料进行多方交叉核实，标注信息来源与可信度等级。对于未经证实的传闻，会明确标注"待核实"标签，帮助读者理性吃瓜。',
  },
  {
    q: '如何参与吃瓜爆料每日大赛？',
    a: '吃瓜爆料每日大赛是平台核心互动栏目，每天评选当日最热爆料内容。用户可以通过投稿入口提交独家爆料，经审核通过后自动参与当日评选。优质爆料投稿者将获得流量推荐与首页展示机会。',
  },
  {
    q: '爆料投稿会被泄露个人信息吗？',
    a: '我们高度重视投稿者隐私保护。所有投稿均采用端到端加密传输，投稿者身份信息严格脱敏处理。平台承诺绝不向任何第三方透露投稿者身份，匿名爆料通道永久开放。',
  },
  {
    q: '吃瓜爆料 APP 有哪些特色功能？',
    a: '吃瓜爆料 APP 支持实时推送通知，确保用户第一时间收到重磅爆料。内置吃瓜爆料视频专区、每日热搜榜单、话题追踪等功能，同时支持离线阅读、个性化内容推荐和社区互动评论。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于吃瓜爆料，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, i) => (
            <details key={i} className="group border border-background-200 rounded-lg overflow-hidden" open={i === 0}>
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line text-sm"></i>
                </span>
                <span className="flex-shrink-0 w-5 h-5 items-center justify-center text-foreground-400 hidden group-open:flex">
                  <i className="ri-subtract-line text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}